export const isInGuidedFlow = (state = false, action) => {
  switch (action.type) {
    case 'SET_IS_IN_GUIDED_FLOW': {
      return action.payload
    }
    default:
      return state
  }
}
